<template>
  <div class="m-main">
    <Header></Header>
    <div class="m-main-bg">
      <div class="carousel">
        <img src="../../assets/img/flndex01.jpg" class="carouselImg" alt="" />
      </div>
      <!-- <div class="m-main-bg-img"> -->
      <!-- <template>
        <el-carousel :interval="4000" arrow="always" class="carousel">
          <el-carousel-item v-for="item in imgArray" :key="item">
            <img :src="item" alt="" class="carouselImg">
          </el-carousel-item>
        </el-carousel>
      </template> -->
      <!-- </div> -->
    </div>
    <div class="card-contain">
      <div
        v-for="(item, i) in cardData"
        :key="i"
        class="card-contain__item"
        @click="goToFn(item.url)"
      >
        <div class="img"><img :src="item.imgsrc" /></div>
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
      </div>
    </div>
    <!-- <div @click="goToFn('/m-index/hld')">
      <img src="../../assets/img/hld1.jpeg"/>
    </div>
    <div>
      <img src="../../assets/img/hld2.jpeg"/>
    </div> -->
    <Footer></Footer>
  </div>
</template>
<script>
import img1 from "../../assets/img/flndex02.png";
import img2 from "../../assets/img/flndex03.png";
import Header from "../menhu/components/m-header.vue";
import Footer from "../menhu/components/m-footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      cardData: [
        {
          imgsrc: img1,
          title: "学校就业查询",
          desc: "“学校就业查询”可以帮助用户了解一所高校的毕业生就业人数和就业去向以及多年的就业趋势，更加直观的了解学校整体就业情况。",
          url: "/forecast/query",
        },
        {
          imgsrc: img2,
          title: "专业就业查询",
          desc: "“专业就业查询”可以查看全国高校的就业率排行榜，每个专业的就业率是指该专业在全国所有学校的综合就业情况。",
          url: "/forecast/ProRank2",
        },
        // {
        //   imgsrc: img3,
        //   title: '学科评估',
        //   desc: '学科评估是教育部学位与研究生教育发展中心（简称学位中心）按照国务院学位委员会和教育部颁布的《学位授予与人才培养学科目录》（简称学科目录）对全国具有博士或硕士学位授予权的一级学科开展整体水平评估。2002年首次开展，截至2017年完成了四轮。',
        //   url: '/configuration/estimate'
        // },
        // {
        //   imgsrc: img4,
        //   title: '专业画像',
        //   desc: '专业画像通过给不同的专业描绘出各自的专业相关的信息，包括该专业的男女比例，毕业生规模等，这些数据充分地从各个维度刻画出当前专业的方方面面，也使相关人员可以第一时间了解到该专业的动态或者想要关注的高校。',
        //   url: '/configuration/portrait'
        // }
      ],
      imgArray: [
        require("../../assets/img/config_carousel_01.jpg"),
        require("../../assets/img/config_carousel_02.jpg"),
        // require('../../assets/img/config_carousel_03.jpg'),
        // require('../../assets/img/config_carousel_04.jpg')
      ],
    };
  },
  methods: {
    goToFn(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style lang="less">
.carousel {
  .el-carousel__container {
    height: 350px;
  }
}
</style>
<style lang="less" scoped>
.m-main {
  // display: flex;
  // padding: 50px 50px 0;
  // justify-content: space-around;
  // background: #f7f8f9;
  height: 100vh;
  overflow: auto;

  .m-main-bg {
    background: #fff;
    width: 80%;
    height: 400px;
    margin: 30px auto;
  }
  // position: relative;
  // &-img {
  //   width: 400px;
  //   margin: 0 auto;
  //   margin-bottom: 20px;
  //   position: absolute;
  //   right: 15%;
  //   > img {
  //     width: 100%;
  //     height: 100%;
  //
  // }
  .card-contain {
    display: flex;
    justify-content: center;
    padding: 20px 10% 0;
    margin-top: -20px;
    margin-bottom: 20px;
    text-align: center;
    > div {
      border: 1px solid #e7ebf0;
      border-radius: 10px;
      max-width: 320px;
      width: 20%;
      background: #ffffff;
      height: 420px;
      .img {
        width: 80%;
        height: 200px;
        border-radius: 10px 10px 0 0;
        margin: 5px auto;
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 10px 10px 0 0;
        }
      }
      .title {
        // text-align: center;
        padding: 20px;
        font-size: 24px;
        font-weight: bolder;
      }
      .desc {
        font-size: 12px;
        color: #6f6f79;
        padding: 0px 20px 10px;
      }
    }
    .card-contain__item {
      cursor: pointer;
    }
    .card-contain__item:hover {
      box-shadow: -2px 0px 5px 1px #e7ebf0, 0px -2px 5px 1px #e7ebf0,
        2px 0px 5px 1px #e7ebf0, 0px 2px 5px 1px #e7ebf0;
    }
    .card-contain__item + .card-contain__item {
      margin-left: 20px;
    }
  }
  .card-contain + .card-contain {
    margin-left: 20px;
  }
  // >div {
  //   width: 36%;
  //   height: 300px;
  //   margin-right: 50px;
  //   border-radius: 20px;
  //   img {
  //     width: 100%;
  //     height: 100%;
  //     display: block;
  //     border-radius: 20px;
  //   }
  // }
  // >div:nth-child(2) {
  //   margin-right: 0;
  // }
}
.carousel {
  height: 350px;
}
// .el-carousel__item .carouselImg {
//   // line-height: 400px;
//   width: 100%;
//   height: 350px;
//   // line-height: 300px;
// }

.carouselImg {
  // line-height: 400px;
  width: 100%;
  height: 350px;
  background-size: auto;
  // line-height: 300px;
}
</style>